import React, { useState } from 'react';
import { database } from '../../firebase';
import { useAuth } from '../../contexts/AuthContext';
import { ROOT_FOLDER } from '../../hooks/useFolder';
import { auth } from '../../firebase';

export default function LoadBaseFolders() {
	//  console.log('Inside Building Folders')
	const currentUser = auth.currentUser;
	//  console.log(currentUser.email)

	var currentFolder = ROOT_FOLDER;

	const path = [...currentFolder.path];

	//  console.log(currentFolder)
	//  console.log(path)
	//  console.log('Adding Folder 1')

	database.folders.add({
		name: 'Completed Assessments',
		parentId: currentFolder.id,
		userId: currentUser.uid,
		path: path,
		createdAt: database.getCurrentTimestamp(),
	});

	//  console.log(currentFolder)
	//  console.log(path)
	//  console.log('Adding Folder 2')

	async function getIdFromFolder() {
		var name = 'Program Area Uploads';
		const { id } = await database.folders.add({
			name: name,
			parentId: currentFolder.id,
			userId: currentUser.uid,
			path: path,
			createdAt: database.getCurrentTimestamp(),
		});
		// console.log('ID SHOULD BE NEXT')
		// console.log('Folder ID is: ', id)

		path.push({ name: name, id: id });

		database.folders.add({
			name: 'Leadership and Governance',
			parentId: id,
			userId: currentUser.uid,
			path: path,
			createdAt: database.getCurrentTimestamp(),
		});
		database.folders.add({
			name: 'Operations',
			parentId: id,
			userId: currentUser.uid,
			path: path,
			createdAt: database.getCurrentTimestamp(),
		});
		database.folders.add({
			name: 'Continual Improvement',
			parentId: id,
			userId: currentUser.uid,
			path: path,
			createdAt: database.getCurrentTimestamp(),
		});
		database.folders.add({
			name: 'Stakeholder Engagement and Satisfaction',
			parentId: id,
			userId: currentUser.uid,
			path: path,
			createdAt: database.getCurrentTimestamp(),
		});
		database.folders.add({
			name: 'Knowledge Management',
			parentId: id,
			userId: currentUser.uid,
			path: path,
			createdAt: database.getCurrentTimestamp(),
		});
		database.folders.add({
			name: 'Workforce Engagement',
			parentId: id,
			userId: currentUser.uid,
			path: path,
			createdAt: database.getCurrentTimestamp(),
		});
	}

	getIdFromFolder();

	database.files.add({
		url: 'https://firebasestorage.googleapis.com/v0/b/pfg-portal.appspot.com/o/FDA_CDER_QMMA_Tool_06.25.2021_v2.1.xlsm?alt=media&token=3cad71ac-7663-4f71-bc31-d3b52ebb646a', // PROD
		name: 'QMMA Assessment Tool',
		createdAt: database.getCurrentTimestamp(),
		folderId: currentFolder.id,
		userId: currentUser.uid,
	});

	return;
}
